import React, { useMemo } from 'react';
import { connect } from 'umi';
import MobilePage from './pages/MobilePage';
import PcPage from './pages/PcPage';
import ConsolePage from './pages/ConsolePage';

const GameStore = ({ gameInfo, userInfo }: any) => {
  const PageInfo = useMemo(() => {
    const pageMap: any = {
      mobile: MobilePage,
      pc: PcPage,
      console: ConsolePage,
    };

    const entity_type = gameInfo.entity_type || 'mobile';
    const Component = pageMap[entity_type];

    return <Component gameInfo={gameInfo} userInfo={userInfo}></Component>;
  }, [gameInfo, userInfo]);

  return PageInfo;
};

export default connect((state: any) => {
  const { opinionCommon, home } = state;

  return {
    gameInfo: opinionCommon.gameInfo,
    userInfo: home.userInfo,
  };
})(GameStore);
